(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["monthly-earrings-landing"] && !Shopify.designMode) return;
  try {
    
  const initializeMonthlyEarrings = (root) => {
    if (root.dataset.mfInitialized === 'true') return;
    root.dataset.mfInitialized = 'true';

    const filters = Array.from(root.querySelectorAll('[data-mf-filter]'));
    const groups = Array.from(root.querySelectorAll('[data-mf-month-group]'));
    const status = root.querySelector('[data-mf-filter-status]');
    if (!filters.length || !groups.length) return;

    const allowedMonths = new Set(['all', ...groups.map((group) => group.dataset.mfMonth)]);
    const allowedModels = new Set(['all', 'hanging', 'studs']);
    const params = new URLSearchParams(window.location.search);
    const state = {
      month: allowedMonths.has(params.get('month')) ? params.get('month') : 'all',
      model: allowedModels.has(params.get('model')) ? params.get('model') : 'all'
    };

    const updateUrl = () => {
      const url = new URL(window.location.href);
      if (state.month === 'all') url.searchParams.delete('month');
      else url.searchParams.set('month', state.month);
      if (state.model === 'all') url.searchParams.delete('model');
      else url.searchParams.set('model', state.model);
      window.history.replaceState({}, '', url);
    };

    const applyFilters = (updateAddress = false) => {
      let visibleProducts = 0;
      groups.forEach((group) => {
        const monthMatches = state.month === 'all' || group.dataset.mfMonth === state.month;
        group.hidden = !monthMatches;
        group.querySelectorAll('[data-mf-product]').forEach((product) => {
          const modelMatches = state.model === 'all' || product.dataset.mfModel === state.model;
          product.hidden = !modelMatches;
          if (monthMatches && modelMatches && product.matches('a')) visibleProducts += 1;
        });
      });

      filters.forEach((filter) => {
        const active = state[filter.dataset.mfFilter] === filter.dataset.mfValue;
        filter.classList.toggle('is-active', active);
        filter.setAttribute('aria-pressed', String(active));
      });

      if (status) status.textContent = `${visibleProducts} köpbara alternativ visas.`;
      if (updateAddress) updateUrl();
    };

    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        state[filter.dataset.mfFilter] = filter.dataset.mfValue;
        applyFilters(true);
      });
    });

    applyFilters(false);
  };

  const initializeAllMonthlyEarrings = (scope = document) => {
    scope.querySelectorAll('[data-mf-earrings-root]').forEach(initializeMonthlyEarrings);
  };

  initializeAllMonthlyEarrings();
  document.addEventListener('shopify:section:load', (event) => initializeAllMonthlyEarrings(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monthly-flower-gift-landing"] && !Shopify.designMode) return;
  try {
    
  const initializeGiftLandings = (root = document) => {
    root.querySelectorAll('[data-gift-landing]:not([data-gift-ready])').forEach((landing) => {
      landing.setAttribute('data-gift-ready', 'true');
      const selector = landing.querySelector('[data-month-select]');
      const submit = landing.querySelector('[data-month-submit]');

      if (selector && submit) {
        selector.addEventListener('change', () => {
          if (selector.value) submit.setAttribute('href', selector.value);
        });
      }

      landing.addEventListener('click', (event) => {
        const link = event.target.closest('[data-month-jump], [data-month-submit]');
        if (!link) return;
        const targetId = link.getAttribute('href');
        if (!targetId || targetId === '#') return;
        const target = landing.querySelector(targetId);
        if (!target) return;
        event.preventDefault();

        const reveal = () => {
          target.open = true;
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        };

        if (document.startViewTransition) {
          document.startViewTransition(reveal);
        } else {
          reveal();
        }
      });
    });
  };

  initializeGiftLandings();
  document.addEventListener('shopify:section:load', (event) => initializeGiftLandings(event.target));

  } catch(e) { console.error(e); }
})();
})();
